import { apiSlice } from "../../app/api/apiSlice";

export const getPublicEligibleProductDetailsSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getPublicEligibleProductDetails: builder.mutation({
			query: (credentials) => ({
				url: `api/v1/loan/public/quick_pricer/product_details/?ob_loan_id=${credentials?.ob_loan_id}&search_id=${credentials?.search_id}&product_id=${credentials?.product_id}`,
				method: "GET",
			}),
		}),
	}),
});

export const { useGetPublicEligibleProductDetailsMutation } =
	getPublicEligibleProductDetailsSlice;
